<template>
    <div class="big-iframe clearfix mt10 mb10">
        <iframe class="big-iframe" :src="`http://test_broker.gsdata.cn/api/common${key}`" frameborder="0" v-if="key != ''"></iframe>
    </div>
</template>
<script>
export default {
    data() {
        return {
            key:this.$route.query.url,
            url:'',
            error:false
        }
    },
    watch: {
        $route(){
            this.key = this.$route.query.url;//获取当前页面url的key
        }
    },
    mounted() {
		let that = this;
    },
    created() {
		
    },
    methods: {
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/help.vue